@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/typography" as t;

.fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 24px;
  text-align: center;
  color: v.$default-text-color;

  @include t.text(14px, 22px, normal);
}
